/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { 
  FiRefreshCw, 
  FiSearch, 
  FiFilter, 
  FiGrid,
  FiList,
  FiUsers,
  FiDollarSign,
  FiTrendingUp,
  FiTrendingDown,
  FiClock,
  FiCheckCircle,
  FiXCircle,
  FiAlertCircle,
  FiUser,
  FiMail,
  FiCalendar,
  FiTag,
  FiArrowUp,
  FiArrowDown,
  FiBarChart2,
  FiAward,
  FiStar,
  FiEye,
  FiFileText,
  FiCreditCard,
  FiPercent
} from "react-icons/fi";
import { 
  MdOutlinePayments, 
  MdOutlineAccountBalance,
  MdOutlineAttachMoney,
  MdOutlinePerson,
  MdOutlineCalendarToday,
  MdOutlineCheckCircle,
  MdOutlineCancel,
  MdOutlinePending,
  MdOutlineRefresh,
  MdOutlineSearch,
  MdOutlineFilter,
  MdOutlineReceipt,
  MdOutlineWallet,
  MdOutlineVisibility,
  MdOutlineDateRange
} from "react-icons/md";
import { IoWalletOutline, IoCashOutline, IoCardOutline, IoTimeOutline } from "react-icons/io5";
import ViewSubTable from './Table/ViewSubTable'
import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import SimpleDeleteModal from '../../components/Delete Modal/SimpleDeleteModal'
import { withdrawalList } from '../../Redux/teacherWithdrawalSlice'
import { getMyWalletTransactionsData } from '../../Redux/paymentsAndTransactionSlice'
import UserPaymentDetails2 from '../Payments & Transactions/Modal/UserPaymentDetails2'

const ViewWithdrawList = () => {
    const [isDeleteModal, setIsDeleteModal] = useState(false)
    const [isUserPaymentModal, setIsUserPaymentModal] = useState(false);
    const [userInfo, setuserInfo] = useState({})
    const [size2,] = useState(10)
    const [pageNo2, setPageNo2] = useState(1)
    const [userId, setUserId] = useState(null);

    const { id } = useParams();
    const dispatch = useDispatch();
    const selector = useSelector((state) => state)
    const { 
        teachersWithdrawal: { withdrawalListData1 = [], withdrawalListTotal1 = [] }, 
        paymentAndTransactionSlice: {userWalletTnxList=[], userWalletTnxListTotal=0} 
    } = selector ? selector : {}
    
    const [keyword, setKeyword] = useState('')
    const [pageNo, setpageNo] = useState(1)
    const [size, setSize] = useState(10)

    const [filter, setFilter] = useState({
        fromDate: "",
        toDate: "",
    })

    let payload = {
        "pageNo": pageNo,
        "size": size,
        "fromDate": filter?.fromDate,
        "toDate": filter?.toDate,
        "keyWord": keyword ? keyword : ""
    }

    let handlePageClick = (newPage) => {
        setpageNo(newPage?.selected + 1)
    }

    useEffect(() => {
        dispatch(withdrawalList({ userId: id, ...payload }))
    }, [dispatch, id, pageNo, size, keyword, filter?.fromDate, filter?.toDate])

    const toggleUserPaymentModal = () => {
        setIsUserPaymentModal(!isUserPaymentModal);
    }
    
    const viewAction = (data) => {
        setuserInfo(data?.userInfo)
        setUserId(data?.userInfo?._id)
        let params = {id: data._id};
        dispatch(getMyWalletTransactionsData({ ...params }))
        setIsUserPaymentModal(!isUserPaymentModal);
    }

    const handlePageClick2 = (data) => {
        const newPageNo = data.selected + 1;
        setPageNo2(newPageNo);
        let params = {
            "keyWord": '',
            "pageNo": String(data.selected + 1),
            "size": String(size2),
            "fromDate": "",
            "toDate": "",
            "sortBy": "",
            "sortOrder": "asc",
            "userId": userId
        }
        dispatch(getMyWalletTransactionsData(params))
    }

    // Calculate statistics
    const totalWithdrawals = withdrawalListTotal1?.length || withdrawalListData1?.length || 0;
    const totalAmount = withdrawalListData1?.reduce((sum, w) => sum + (w?.amount || 0), 0) || 0;
    const totalAdminFee = withdrawalListData1?.reduce((sum, w) => sum + (w?.adminFee || 0), 0) || 0;
    const pendingCount = withdrawalListData1?.filter(w => w?.status === 'pending')?.length || 0;
    const completedCount = withdrawalListData1?.filter(w => w?.status === 'completed' || w?.status === 'approved')?.length || 0;

    return (
        <div className="min-h-screen bg-gray-50/80">
            {/* Header Banner */}
            <div className="bg-gradient-to-r from-[#855DF6] via-[#7B5CF6] to-[#715EFE] shadow-lg relative overflow-hidden">
                <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20 animate-pulse"></div>
                <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-12 -mb-12 animate-pulse"></div>
                <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
                
                <div className="relative z-10 px-4 md:px-7 py-6 md:py-8">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                        <div className="flex items-center gap-3">
                            <div className="p-2.5 bg-white/20 rounded-xl backdrop-blur-sm shadow-lg">
                                <MdOutlineWallet className="w-5 h-5 text-white md:w-6 md:h-6" />
                            </div>
                            <div>
                                <h2 className="text-xl font-bold text-white md:text-2xl dahboardFont tracking-tight">
                                    Withdrawal Details
                                </h2>
                                <p className="text-sm text-white/70 hidden sm:block">
                                    View and manage withdrawal requests
                                </p>
                            </div>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="flex items-center gap-2 px-3 py-1.5 bg-white/20 rounded-full backdrop-blur-sm">
                                <FiRefreshCw className="w-3.5 h-3.5 text-white/70" />
                                <span className="text-xs text-white/80">
                                    {new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Stats Cards */}
                    <div className="grid grid-cols-2 gap-3 mt-5 sm:grid-cols-4 md:gap-4">
                        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-[10px] font-medium text-white/60 uppercase tracking-wider">Total</p>
                                    <p className="text-xl font-bold text-white md:text-2xl mt-0.5">{totalWithdrawals}</p>
                                </div>
                                <div className="p-2 rounded-xl bg-blue-500/30 shadow-inner">
                                    <MdOutlineReceipt className="w-4 h-4 text-white md:w-5 md:h-5" />
                                </div>
                            </div>
                        </div>
                        {/* <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-[10px] font-medium text-white/60 uppercase tracking-wider">Amount</p>
                                    <p className="text-xl font-bold text-emerald-300 md:text-2xl mt-0.5">${totalAmount.toFixed(2)}</p>
                                </div>
                                <div className="p-2 rounded-xl bg-emerald-500/30 shadow-inner">
                                    <FiDollarSign className="w-4 h-4 text-emerald-300 md:w-5 md:h-5" />
                                </div>
                            </div>
                        </div>
                        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-[10px] font-medium text-white/60 uppercase tracking-wider">Admin Fee</p>
                                    <p className="text-xl font-bold text-amber-300 md:text-2xl mt-0.5">${totalAdminFee.toFixed(2)}</p>
                                </div>
                                <div className="p-2 rounded-xl bg-amber-500/30 shadow-inner">
                                    <FiPercent className="w-4 h-4 text-amber-300 md:w-5 md:h-5" />
                                </div>
                            </div>
                        </div>
                        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
                            <div className="flex items-center justify-between">
                                <div>
                                    <p className="text-[10px] font-medium text-white/60 uppercase tracking-wider">Pending</p>
                                    <p className="text-xl font-bold text-amber-300 md:text-2xl mt-0.5">{pendingCount}</p>
                                </div>
                                <div className="p-2 rounded-xl bg-amber-500/30 shadow-inner">
                                    <FiClock className="w-4 h-4 text-amber-300 md:w-5 md:h-5" />
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <section className="px-3 py-4 -mt-4 md:px-6 lg:px-10 md:py-6">
                <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
                    <div className="p-3 md:p-4">
                        <ViewSubTable
                            TableName={`Withdrawal List`}
                            TableHeader={['#', 'User', 'Amount', 'Admin Fee', 'Transfer Id', 'Type', 'Release Date', 'View Transactions']}
                            TableData={withdrawalListData1}
                            keyword={keyword}
                            setKeyword={setKeyword}
                            pageNo={pageNo}
                            setpageNo={setpageNo}
                            size={size}
                            total={withdrawalListTotal1?.length || withdrawalListData1?.length || 0}
                            setSize={setSize}
                            handlePageClick={handlePageClick}
                            setFilter={setFilter}
                            filter={filter}
                            viewAction={viewAction}
                        />
                    </div>
                </div>
            </section>

            {/* Modals */}
            {isDeleteModal && (
                <SimpleDeleteModal
                    isOpen={isDeleteModal}
                    title={`Delete`}
                    onCancel={() => setIsDeleteModal(false)}
                />
            )}
            
            {isUserPaymentModal && (
                <UserPaymentDetails2 
                    pageNo={pageNo2} 
                    userInfo={userInfo} 
                    onClose={toggleUserPaymentModal} 
                    transactions={userWalletTnxList} 
                    title={`Transaction History`} 
                    size={size2} 
                    total={userWalletTnxListTotal} 
                    handlePageClick={handlePageClick2} 
                />
            )}
        </div>
    )
}

export default ViewWithdrawList